let dev
let API_URL

API_URL = process.env.REACT_APP_API_ROUTE;
// API_URL = 'http://localhost:5000'
module.exports = {
    USER: {
        LOGIN: `${API_URL}/user/authenticate`,
        AUTH: `${API_URL}/user/auth/:id`
    },
    PATIENT: {
        CREATE: `${API_URL}/patient/create`,
        GETALL: `${API_URL}/patient`,
        GET: `${API_URL}/patient/:id`,
        UPDATE: `${API_URL}/patient/:id`,
        REMOVE: `${API_URL}/patient/:id`
    },
    TREATMENT: {
        CREATE: `${API_URL}/treatment/create`,
        GETALL: `${API_URL}/treatment`,
        GET: `${API_URL}/treatment/:id`,
        UPDATE: `${API_URL}/treatment/:id`,
        REMOVE: `${API_URL}/treatment/:id`
    },
    EXAM: {
        CREATE: `${API_URL}/exam/create`,
        GETALL: `${API_URL}/exam`,
        GET: `${API_URL}/exam/:id`,
        UPDATE: `${API_URL}/exam/:id`,
        REMOVE: `${API_URL}/exam/:id`
    },
    TYPE_EXAM: {
        CREATE: `${API_URL}/typeexam/create`,
        GETALL: `${API_URL}/typeexam`,
        GET: `${API_URL}/typeexam/:id`,
        UPDATE: `${API_URL}/typeexam/:id`,
        REMOVE: `${API_URL}/typeexam/:id`
    }
}